type Props = {
  size: number;
  color?: string;
};

const ShuttleBus = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3334 5.25C22.1618 5.25 22.8334 5.92157 22.8334 6.75V15.75C22.8334 16.5784 22.1618 17.25 21.3334 17.25H21.2357C20.9024 18.5435 19.731 19.5 18.3334 19.5C16.9358 19.5 15.7643 18.5435 15.431 17.25H9.98572C9.65242 18.5435 8.48098 19.5 7.08337 19.5C5.68577 19.5 4.51433 18.5435 4.18103 17.25H3.33337C2.50495 17.25 1.83337 16.5784 1.83337 15.75V11.5049C1.83338 11.3363 1.86171 11.1689 1.91736 11.0098L3.58142 6.25488C3.79197 5.6533 4.36009 5.25007 4.99744 5.25H21.3334ZM7.08337 15C6.25495 15 5.58337 15.6716 5.58337 16.5C5.58337 17.3284 6.25495 18 7.08337 18C7.9118 18 8.58337 17.3284 8.58337 16.5C8.58337 15.6716 7.9118 15 7.08337 15ZM18.3334 15C17.5049 15 16.8334 15.6716 16.8334 16.5C16.8334 17.3284 17.5049 18 18.3334 18C19.1618 18 19.8334 17.3284 19.8334 16.5C19.8334 15.6716 19.1618 15 18.3334 15ZM3.42224 11.25H7.83337V6.75H4.99744L3.42224 11.25ZM9.33337 9.75H12.3334V6.75H9.33337V9.75ZM13.8334 9.75H16.8334V6.75H13.8334V9.75ZM18.3334 9.75H21.3334V6.75H18.3334V9.75Z"
        fill={color || '#212222'}
      />
    </svg>
  );
};

export default ShuttleBus;
